import { cssVars, cx } from '@/lib/cx';
import s from './ProgressBar.module.css';

export function ProgressBar({
  value,
  max = 100,
  tone = 'primary',
  label,
  showValue,
  className,
}: {
  value: number;
  max?: number;
  tone?: 'primary' | 'good' | 'medium' | 'bad';
  label: string;
  showValue?: boolean;
  className?: string;
}) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div className={cx(s.wrap, className)}>
      <div className={s.track} role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={max} aria-valuenow={value}>
        <div className={cx(s.bar, s[tone])} style={cssVars({ '--pct': `${pct}%` })} />
      </div>
      {showValue && <span className={s.value}>{Math.round(pct)}%</span>}
    </div>
  );
}
